export default __webpack_public_path__ + "static/media/php-logo.7f2fb6e3.svg";